import { Component } from 'react';
import './Testimonials.css';
import { testimonials } from '../../config'

const WAIT_INTERVAL = 8000; // 8 seconds

class Testimonials extends Component {
  state = {
    currentTestimonialIndex: 0,
  }

  testimonialRefs = [];

  componentDidMount() {
    this.createTimer();
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  createTimer = () => {
    this.timer = setInterval(() => {
      const { currentTestimonialIndex } = this.state;
      let nextIndex = currentTestimonialIndex + 1;
      nextIndex = nextIndex >= testimonials.length ? 0 : nextIndex;
      this.setState({ currentTestimonialIndex: nextIndex });
    }, WAIT_INTERVAL);
  }

  markerButtonAction = index => event => {
    if (event.type==='click' || event.key === ' ' || event.key === 'Enter') {
      this.setState({ currentTestimonialIndex: index }, () => {
        clearInterval(this.timer)
        this.createTimer()
      })
    }
  }

  render() {
    const { currentTestimonialIndex } = this.state
    return (
      <div className="Testimonials">

        <div className="container">
          <div className="row">
            <div className="col">
              <h2 className='mb-4'>Testimonials</h2>

              <div className='testimonial-carousel'>
                {testimonials.map((testimonial, index) => (
                  <figure
                    className={`blockquote testimonial-slide ${currentTestimonialIndex === index ? 'active' : ''}`}
                    key={testimonial.quote}
                    ref={ref => this.testimonialRefs[index] = ref}
                  >
                    <blockquote className="blockquote">
                      <p>{testimonial.quote}</p>
                    </blockquote>
                    <figcaption className="blockquote-footer">
                      {testimonial.author} <cite title="Testimonial Author Organiztion">{testimonial.source}</cite>
                    </figcaption>
                  </figure>
                ))}
              </div>
            </div>
          </div>
        </div>

        <ul className='testimonial-markers'>
          {testimonials.map((testimonial, index) => (
            <li
              key={`control-${testimonial.quote}`}
              onClick={this.markerButtonAction(index)}
              onKeyUp={this.markerButtonAction(index)}
              className={currentTestimonialIndex === index ? 'active' : ''}
              role="button"
              tabIndex="0"
            />
          ))}
        </ul>

      </div>
    )
  }
}

export default Testimonials;
